import React from 'react';
import { Route, withRouter } from 'react-router';
import TestForm from "./components/testForm";
import { Container } from 'semantic-ui-react'


const Test = () => {
    return (
        <Container>
            {/* <Route path="/test/list" component={withRouter(TestList)} /> */}
            {/* <Route path="/test/edit/:id" component={TestForm} /> */}
            <Route path="/test/create" component={TestForm} />
        </Container>
    )
};

export default Test;

